
import {defineComponent} from "vue"
import Divider from "primevue/divider";

export default defineComponent({
  name: "Footer",
  components: {Divider}
})
